// extracted by mini-css-extract-plugin
module.exports = {"root":"VerticalNavigation_root__29EJ-","link":"VerticalNavigation_link__1Os5t","areaHeader":"VerticalNavigation_areaHeader__1O92x"};